import React from 'react';
import { SelectField as SelectFieldType } from '../../types/optionTypes';

interface SelectFieldProps {
    field: SelectFieldType;
    value: any;
    onChange: (value: any) => void;
}

export const SelectField: React.FC<SelectFieldProps> = ({ field, value, onChange }) => {
    return (
        <div className="w-full">
            {field.label && (
                <label className="block text-sm font-medium text-gray-800 mb-2">
                    {field.label}
                    {field.required && <span className="text-red-500 ml-1">*</span>}
                    {field.tooltip && field.tooltip_type === 'popup' && (
                        <button
                            type="button"
                            className="ml-2 text-blue-600 hover:text-blue-800 inline-flex items-center"
                            onClick={() => {
                                const tooltipWindow = window.open('', 'tooltip', 'width=600,height=400,scrollbars=yes');
                                if (tooltipWindow) {
                                    tooltipWindow.document.write(`
                                        <html>
                                            <head><title>${field.label} - 詳細</title></head>
                                            <body style="font-family: sans-serif; padding: 20px;">
                                                ${field.tooltip}
                                            </body>
                                        </html>
                                    `);
                                }
                            }}
                            title="詳細を見る"
                        >
                            <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
                            </svg>
                        </button>
                    )}
                </label>
            )}

            <select
                value={value || ''}
                onChange={(e) => {
                    console.log('SelectField onChange:', field.name, e.target.value);
                    onChange(e.target.value);
                }}
                required={field.required}
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md shadow-sm bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors hover:border-gray-400"
            >
                <option value="">{field.placeholder || 'ご選択ください'}</option>
                {field.values.map((option) => (
                    <option key={option.tempId} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>

            {field.description && (
                <div className="mt-1.5 text-xs text-gray-600 leading-relaxed" dangerouslySetInnerHTML={{ __html: field.description }} />
            )}
            {field.errorMessage && (
                <p className="text-xs text-red-500 mt-1">{field.errorMessage}</p>
            )}
        </div>
    );
};
